import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { ExportModalComponent } from '../export-modal/export-modal.component';
import { CommonModule } from '@angular/common';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';
import { LockedButtonComponent } from 'src/app/shared/components/locked-button/locked-button.component';
import { LimitedFeatures } from 'src/app/shared/models/pack.models';

@Component({
  selector: 'app-export-trips-to-xls',
  imports: [
    ButtonModule,
    TranslocoPipe,
    ExportModalComponent,
    CommonModule,
    LockedButtonComponent,
  ],
  templateUrl: './export-trips-to-xls.component.html',
})
export class ExportTripsToXlsComponent {
  packLimitationService = inject(PackLimitationsService);
  showExportModal = false;
  canExportExcel = this.packLimitationService.canExportExcel;
  xlsFeature = LimitedFeatures.Excel
}
